export default "__VITE_ASSET__CnG44Rjw__"